import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { MESSAGES, UNREAD_MESSAGES_COUNT } from '../constants/queryKeys';
import useAxiosPrivate from './useAxiosPrivate';
import useUIStore from '../stores/UIStore';

export default function useMarkMessageAsRead() {
  const { t } = useTranslation();

  const { toast } = useUIStore();

  const axios = useAxiosPrivate();

  const queryClient = useQueryClient();

  async function markMessageAsRead() {
    const res = await axios.patch('/messages/mark-as-read');
    return res.data;
  }

  function onError() {
    toast.current?.show({
      severity: 'error',
      summary: t('common.message-saving-failed'),
      detail: t('common.message-saving-failed-description'),
    });
  }

  return useMutation({
    mutationFn: markMessageAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries([MESSAGES, UNREAD_MESSAGES_COUNT]);
      queryClient.setQueryData([UNREAD_MESSAGES_COUNT], 0);
    },
    onError,
  });
}
